import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Dashboard from "../layout/dashboard";
import Reflayout from "../layout/referensi/index.js";
import Portallayout from "../layout/portal.js";
import FinanceLayout from "../layout/finance.js";
import InventoryLayout from "../layout/inventory.js";
import PitaLayout from "../layout/pita.js";
import MonitoringLayout from "../layout/monitoring.js";
import OtherLayout from "../layout/other.js";
import CustomsLayout from "../layout/laporan-bc.js";
import LoginPage from "../pages/auth/login.js";
import PemuatanPrint from "../pages/inventory/pemuatan/print";
import PemusnahanPrint from "../pages/inventory/pemusnahan/print";
import PelekatanPrint from "../pages/pelekatan/print";
import IncomingPcPrint from "../pages/pita/print";
import MyProfile from "../pages/profile/MyProfile";
import MyActivity from "../pages/profile/MyActivity";
import Email from "../pages/email/Email";

const IndexRouters = () => {
  return (
    <Switch>
      {/* Route login duluan */}
      <Route exact path="/login" component={LoginPage} />
      <Route path="/print/pemuatan/:id" component={PemuatanPrint} />
      <Route path="/print/pemusnahan/:id" component={PemusnahanPrint} />
      <Route path="/print/pelekatan/:id" component={PelekatanPrint} />
      <Route path="/print/incoming-pc/:id" component={IncomingPcPrint} />

      {/* Root redirect ke /login atau /dashboard, sementara ke /login dulu */}
      <Route exact path="/">
        <Redirect to="/login" />
      </Route>

      {/* Profile Routes */}
      <Route exact path="/profile" component={MyProfile} />
      <Route exact path="/my-activity" component={MyActivity} />
      <Route exact path="/email" component={Email} />

      {/* Route lain */}
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/portal" component={Portallayout} />
      <Route path="/referensi" component={Reflayout} />
      <Route path="/finance" component={FinanceLayout} />
      <Route path="/inventory" component={InventoryLayout} />
      <Route path="/pita" component={PitaLayout} />
      <Route path="/other" component={OtherLayout} />
      <Route path="/monitoring" component={MonitoringLayout} />
      <Route path="/customsreport" component={CustomsLayout} />
    </Switch>
  );
};

export default IndexRouters;

